/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  transactionCountListChainKeyTransactionCountApiV1ChainKeyLedgersTransactionCountGet,
} from "../../funcs/transactionCountListChainKeyTransactionCountApiV1ChainKeyLedgersTransactionCountGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .ListChainKeyTransactionCountApiV1ChainKeyLedgersTransactionCountGetRequest$inboundSchema
    .optional(),
};

export const tool$transactionCountListChainKeyTransactionCountApiV1ChainKeyLedgersTransactionCountGet:
  ToolDefinition<typeof args> = {
    name: "chain-key-tx-count-v1",
    description: `Original tool name: transaction-count-list-chain-key-chain-key-ledgers-transaction-count-get

List aggregated transaction count for chain key ledgers`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await transactionCountListChainKeyTransactionCountApiV1ChainKeyLedgersTransactionCountGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };